var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.MenuUnderlay = new Class({
    Implements: [Options, Events],
    element: null,
    options: {
        selector_id: "menu_underlay",
        hidden_class: "hidden"
    },
    bound_methods: {},
    initialize: function (ops) {
        this.setOptions(ops);
        this.bound_methods.click = this.click.bind(this);
        this.element = document.id(this.options.selector_id);
        if (this.element) {
            var self = this.element.retrieve('menu_obj');
            if (self) {
                return self;
            } else {
                this.element.store('menu_obj', this);
            }
            this.element.addEvent('click', this.bound_methods.click);
            this.hide();
        }
    },
    show: function () {
        if (this.element.hasClass(this.options.hidden_class)) {
            this.element.removeClass(this.options.hidden_class);
        }
    },
    hide: function () {
        if (!this.element.hasClass(this.options.hidden_class)) {
            this.element.addClass(this.options.hidden_class);
        }
    },
    click: function (e) {
        OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
    }
});